import React from "react";

const MeetingPublicLayout = ({ children }) => {
  return (
    <div className="tw-min-h-screen tw-bg-white tw-flex tw-flex-col">
      <main className="tw-flex-grow">
        {children}
      </main>
    </div>
  );
};

export default MeetingPublicLayout;
